import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import CheckIcon from '@material-ui/icons/Check';
import ErrorIcon from '@material-ui/icons/Error';

import { toUpperFirstLetter, validateEmail } from '../../../../../util/helpers';
import './results-table.scss';

const roles = ['admin', 'manager', 'operative'];

const columns = [
  {
    id: 'status',
    label: 'Status',
    minWidth: 50,
    align: 'left',
    format: (value) => (value === 'success' ? <CheckIcon htmlColor="green" /> : <ErrorIcon htmlColor="red" />),
  },
  { id: 'firstName', label: 'First Name*', minWidth: 100 },
  { id: 'lastName', label: 'Last Name*', minWidth: 100 },
  {
    id: 'email',
    label: 'Email*',
    minWidth: 100,
    align: 'left',
    format: (value, err) =>
      !err && validateEmail(value) ? (
        value
      ) : (
        <div className="err">
          <ErrorIcon htmlColor="red" fontSize="small" />
          <div>
            {value}
            <p className="err-text">{err ? err : 'Please, check Email'}</p>
          </div>
        </div>
      ),
  },
  { id: 'phone', label: 'Phone', minWidth: 100, align: 'left' },
  {
    id: 'role',
    label: 'Role*',
    minWidth: 100,
    align: 'left',
    format: (value) =>
      roles.includes(value.toLowerCase()) ? (
        toUpperFirstLetter(value)
      ) : (
        <div className="err">
          <ErrorIcon htmlColor="red" fontSize="small" />
          <div>
            {toUpperFirstLetter(value)}
            <p className="err-text">(Admin, Manager, Operative)</p>
          </div>
        </div>
      ),
  },
  { id: 'position', label: 'Position', minWidth: 100, align: 'left', format: (value) => toUpperFirstLetter(value) },
  {
    id: 'description',
    label: 'Description',
    minWidth: 100,
    align: 'left',
    format: (value) => toUpperFirstLetter(value),
  },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    height: 650,
  },
});

const ResultsTable = ({ rows }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && value ? column.format(value, row.error) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default ResultsTable;
